import React from "react";
import FieldLabel from "../../../../components/label";
import ChipSelect from "../../../../components/chipSelect";
import AppointeeMobileDetails from "./mobile";
import AppointeeEmailDetails from "./email";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import { withStyles } from "@mui/styles";
import { useStyles } from "../../indexFormStyles";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { getMinDobDate, getMaxDobDate } from "../../../../helpers/buyflow";
import { isAppointeePersonalDetailsMissing } from "../../../../helpers/nominee";

function AppointeePersonalDetails({
  classes: { accordianSection, contentScroller, formGroup },
  dateRange,
  errorMessage,
  form,
  handleAccordionChange,
  handleChange,
  handleChangeChipSelect,
  options,
  section,
  validateInputLength,
}) {
  return (
    <>
      <Box
        className={accordianSection}
        onClick={() =>
          handleAccordionChange("appointeePersonal", section.appointeePersonal)
        }
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {isAppointeePersonalDetailsMissing(form, errorMessage) && (
            <NewReleasesOutlinedIcon />
          )}
          {!isAppointeePersonalDetailsMissing(form, errorMessage) && (
            <CheckCircleOutlineIcon sx={{ color: "green" }} />
          )}
          <Typography variant="subtitle2">Appointee Details</Typography>
        </Stack>
        <Box>
          {!section.appointeePersonal && <ExpandMoreIcon fontSize="medium" />}
          {section.appointeePersonal && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>

      {section.appointeePersonal && (
        <Box p={1} mt={0} sx={{ height: "364px" }} className={contentScroller}>
          <Box>
            <Box className={formGroup} pt={0}>
              <FieldLabel label={"Full Name*"} />
              <TextField
                id="standard-basic"
                variant="outlined"
                value={form.appointee_name}
                name="appointee_name"
                onChange={handleChange}
                onInput={validateInputLength}
                autoComplete="off"
                helperText={errorMessage.appointee_name}
                fullWidth
              />
            </Box>

            <Box className={formGroup} pt={0}>
              <FieldLabel label={"Relationship*"} />
              <FormControl
                variant="outlined"
                style={{ width: "100%", textAlign: "left" }}
                fullWidth
              >
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={form.appointee_relationship}
                  onChange={handleChange}
                  name="appointee_relationship"
                  disabled={!form.appointee_name}
                >
                  <MenuItem value={""}>
                    <em>Select</em>
                  </MenuItem>

                  {["Mother", "Father", "Grandmother", "Grandfather"].map(
                    (item) => {
                      return (
                        <MenuItem value={item} key={item}>
                          {item}
                        </MenuItem>
                      );
                    }
                  )}

                  {/* <MenuItem value={"Mother"}>Mother</MenuItem>
                  <MenuItem value={"Father"}>Father</MenuItem>
                  <MenuItem value={"Grandmother"}>Grandmother</MenuItem>
                  <MenuItem value={"Grandfather"}>Grandfather</MenuItem> */}
                </Select>
                {errorMessage.appointee_relationship && (
                  <Box className="error-message">
                    {"Please select relationship"}
                  </Box>
                )}
              </FormControl>
            </Box>

            <Box className={formGroup} pt={0}>
              <FieldLabel label={"Date of Birth*"} />
              <TextField
                type="date"
                id="standard-basic"
                variant="outlined"
                value={form.appointee_dob}
                name="appointee_dob"
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.appointee_dob}
                fullWidth
                InputProps={{
                  inputProps: {
                    min: dateRange.appointee.min,
                    max: dateRange.appointee.max,
                  },
                }}
                disabled={!form.appointee_relationship}
              />
            </Box>

            <Box className={formGroup} pt={0} pb={0}>
              <FieldLabel label={"Gender*"} />
              <ChipSelect
                fieldname={"appointee_gender"}
                handleChange={handleChangeChipSelect}
                options={options.gender}
                selectedItem={form.appointee_gender}
                disabled={true}
              />
            </Box>
          </Box>

          <AppointeeMobileDetails
            errorMessage={errorMessage}
            form={form}
            handleAccordionChange={handleAccordionChange}
            handleChange={handleChange}
            handleChangeChipSelect={handleChangeChipSelect}
            options={options}
            validateInputLength={validateInputLength}
          />

          <AppointeeEmailDetails
            errorMessage={errorMessage}
            form={form}
            handleAccordionChange={handleAccordionChange}
            handleChange={handleChange}
            handleChangeChipSelect={handleChangeChipSelect}
            options={options}
            validateInputLength={validateInputLength}
          />
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  AppointeePersonalDetails
);
